<!-- Clean, intentional design with only 2,4,8 spacing -->
<div class="min-h-screen bg-gradient-to-br from-brand-briefcream via-brand-nude/20 to-brand-briefcream p-4"
  style="background-image: radial-gradient(circle at 1px 1px, rgba(214, 179, 112, 0.15) 1px, transparent 0); background-size: 20px 20px;">
  <div class="max-w-6xl mx-auto">

    <!-- Header: Clear hierarchy with 2,4,8 spacing -->
    <header class="text-center mb-8 py-8">
      <h1 class="font-[Parisienne] text-3xl text-brand-inktint mb-4">Hochzeits-FAQ</h1>
      <div class="flex items-center justify-center space-x-4">
        <div class="w-8 h-px bg-brand-goldline"></div>
        <span class="font-[Neuton] text-xl text-brand-inktint">1. August 2026</span>
        <div class="w-8 h-px bg-brand-goldline"></div>
      </div>
      <p class="font-[Neuton] text-brand-inktint/80 mt-4 max-w-2xl mx-auto">
        Hier findet ihr Antworten auf alle wichtigen Fragen rund um unseren Hochzeitstag.
      </p>
    </header>

    <!-- FAQ Cards: Flexible content projection for maximum customization -->
    <div class="flex flex-col gap-12">

      <!-- Gottesdienst Card -->
      <info-card [reversed]="false">
        <div card-header>
          <h3 class="font-[Parisienne] text-3xl text-brand-inktint mb-1">Gottesdienst</h3>
          <p class="font-[Neuton] text-lg text-brand-goldline">Adresse & Anfahrt</p>
        </div>
        <div card-content class="space-y-3"></div>
        <div card-sidebar>
          <ul class="pl-5 text-brand-inktint/80">
            <li>Die Trauung findet in der ev. Marienkirche in Blasheim
              (<a href="https://www.google.com/maps/search/?api=1&query=Postweg+2,+Blasheim" target="_blank"
                rel="noopener" class="underline hover:text-brand-inktint">Google Maps</a>)
              statt. Parkplätze sind am Friedhof gegenüber vorhanden.
            </li>
            <li>Die Trauung beginnt um 16:00 Uhr.</li>
            <li>Da wir dort nach dem Gottesdienst auch einen Sektempfang haben, bietet es sich an, bereits vor dem
              Gottesdienst ins Hotel einzuchecken.</li>
          </ul>
        </div>
      </info-card>

      <!-- Garten Card -->
      <info-card [reversed]="true">
        <div card-header>
          <h3 class="font-[Parisienne] text-4xl text-brand-inktint mb-2">Die Feier</h3>
          <p class="font-[Neuton] text-xl text-brand-goldline mb-4">Findet die Feier drinnen oder draußen statt?</p>
        </div>
        <div card-content></div>
        <div card-sidebar>
          <p class="text-brand-inktint/80">
            Wir feiern draußen im Garten (<a
              href="https://www.google.com/maps/place/Hedemer+Str.+69,+32312+L%C3%BCbbecke/@52.3368321,8.5539976,17z/">Google
              Maps</a>) mit Überdachung. Für schattige Plätze und Schutz vor Regen ist gesorgt. Parkplätze gibt es an
            der Kirche und dem Friedhof in Alswede, die sich nebenan beziehungsweise gegenüber befinden.
          </p>
        </div>
      </info-card>
      <!-- Übernachtung Card -->
      <info-card [reversed]="false">
        <div card-header>
          <h3 class="font-[Parisienne] text-4xl text-brand-inktint mb-2">Übernachtung</h3>
          <p class="font-[Neuton] text-xl text-brand-goldline mb-4">Wo können wir übernachten?</p>
        </div>
        <div card-content>

        </div>
        <div card-sidebar>
          <ul class="pl-5 text-brand-inktint/80">
            <li>
              <a href="https://schloss-benkhausen.de/" target="_blank" rel="noopener"
                class="underline hover:text-brand-inktint">In Schloss Benkhausen</a> sind Zimmer für uns reserviert
              (Stichwort:
              Hochzeit Bökelmann-Röthemeyer, Reservierung per E-Mail möglich). Die Strecke von der Feier zum Hotel ist
              gut zu Fuß machbar.
            </li>
            <li>Weitere Unterkünfte gibt es in den umliegenden Dörfern. Wir helfen euch gern, die Wege zu planen.</li>
          </ul>
        </div>
      </info-card>

      <!-- Kleidung Card -->
      <info-card [reversed]="true">
        <div card-header>
          <h3 class="font-[Parisienne] text-4xl text-brand-inktint mb-2">Kleidung</h3>
          <p class="font-[Neuton] text-xl text-brand-goldline mb-4">Was sollen wir anziehen?</p>
        </div>
        <div card-content></div>
        <div card-sidebar>
          <p>Wir freuen uns über elegante Kleidung passend zur Kirche und zum Fest. Die Feier findet im Garten statt,
            für Überdachung sorgen wir. Für den Abend stellen wir Decken bereit. Und da wir tanzen möchten, sind bequeme
            Schuhe eine
            gute Wahl.</p>
        </div>
      </info-card>


      <!-- Kinder Card -->
      <info-card [reversed]="false">
        <div card-header>
          <h3 class="font-[Parisienne] text-4xl text-brand-inktint mb-2">Kinder</h3>
          <p class="font-[Neuton] text-xl text-brand-goldline mb-4">Kann ich meine Kinder mitbringen?</p>
        </div>
        <div card-content></div>
        <div card-sidebar>
          <p class="text-brand-inktint/80">
            Kinder dürfen gern mitkommen (bitte bei der Anmeldung angeben). Wir bereiten eine schattige Ecke mit
            Beschäftigungsmöglichkeiten vor. Falls ihr diese mitgestalten wollt, freuen wir uns sehr. Sollten eure
            Kinder während des Gottesdienstes eine kleine Pause brauchen, könnt ihr mit ihnen gern den neuen Dorfplatz
            neben der Kirche nutzen.
          </p>
        </div>
      </info-card>

      <!-- Geschenke Card -->
      <info-card [reversed]="true">
        <div card-header>
          <h3 class="font-[Parisienne] text-4xl text-brand-inktint mb-2">Geschenke</h3>
          <p class="font-[Neuton] text-xl text-brand-goldline mb-4">Was können wir euch schenken?</p>
        </div>
        <div card-content></div>
        <div card-sidebar>
          <p class="text-brand-inktint/80">
            Das schönste Geschenk für uns ist eure Anreise und dass ihr unseren besonderen Tag mit uns feiert.
            Darüber hinaus haben wir bereits alles, was wir brauchen. Falls ihr uns dennoch eine Freude machen möchtet,
            würden wir uns über einen Beitrag zu unserer gemeinsamen Zukunft freuen.
          </p>
        </div>
      </info-card>


    </div>

    <!-- Action Cards: Vertical stack with full width and gap-12 -->
    <footer class="mt-8">
      <div class="flex flex-col gap-12">
        @for (actionCard of actionCards(); track actionCard.title; let i = $index) {
        <action-card [data]="actionCard" [variant]="$even ? 'primary' : 'secondary'">
        </action-card>
        }
      </div>
    </footer>

  </div>